document.addEventListener('DOMContentLoaded', () => {
  const productGridContainer = document.querySelector('#ProductGridContainer');

  if (!productGridContainer) return;

  const resetAlternateImages = () => {
    document.querySelectorAll('.product-item_image-alternate').forEach((img) => {
      img.style.display = 'none';
      img.style.opacity = '0';
    });
  };

  const reinitWebflowInteractions = () => {
    if (window.Webflow && window.Webflow.require) {
      try {
        window.Webflow.require('ix2').init();
      } catch (error) {
        console.warn('Webflow IX2 reinit failed:', error);
      }
    }
  };

  const handleCollectionGridUpdate = () => {
    setTimeout(() => {
      resetAlternateImages();
      reinitWebflowInteractions();
    }, 150);
  };

  resetAlternateImages();

  const observer = new MutationObserver(() => {
    handleCollectionGridUpdate();
  });

  observer.observe(productGridContainer, {
    childList: true,
    subtree: true,
  });
});